// Regulators.js
import React, { useEffect, useState } from 'react';
import { isAuthenticated } from '../auth';
import LoginPopup from './LoginPopup';
import Header from './Header';
import DataTable from './DataTable';
import Carousel from './Carousel';
import { CHAIN_CONNECTIONS } from '../config';
import '../Styles/Regulators.css';

const Regulators = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [imageDisplay, setImageDisplay] = useState('none');
  const supportedNetworks = Object.values(CHAIN_CONNECTIONS).map(chain => chain.networkName);

  //const imageAdgm = "/adgmLogo.png"
  const imageMonflo = "/monflo.jpg"


  useEffect(() => {
    // Update the imageSrc state with the correct image link when it's available
    const newImageSrc = "none";
    setImageSrc(newImageSrc);

    // If the image link is not empty, set the display property to make the image visible
    if (newImageSrc) {
      setImageDisplay('block');
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated()) {
      setShowLoginPopup(true);
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('username') !== null) {
      document.getElementById("userName").innerHTML = sessionStorage.getItem('username');

      if (sessionStorage.getItem('username') === "monflo_officer") {
        setImageSrc(imageMonflo)
      }
    }
  }, []);

  const onLoginSuccess = () => {
    setShowLoginPopup(false);
  };


  const handleClosePopup = () => {
    setShowLoginPopup(false);
  };

  // <img className="companyLogo" src={imageSrc} alt="Comapny image" style={{ display: imageDisplay }} />

  return (
    <div className="RegBody">
      <Header>
        <button className="teamButton" id="userName" disabled>Hello!</button>
      </Header>
      <div className='titleReg'>
        <h1 className="titleRegLetters">
          Regulatory Dashboard Oversight
        </h1>
      </div>

      {showLoginPopup && (
        <LoginPopup onClose={handleClosePopup} onLoginSuccess={onLoginSuccess} />
      )}
      <div>
        {
          isAuthenticated() &&
          <DataTable
            isAuthenticated={isAuthenticated()}
          />
        }
      </div>
      <div className='AllNetIds'>
        <Carousel supportedNetworks={supportedNetworks} velocity={2} />
      </div>
    </div>
  );
};

export default Regulators;